import type { LinkItem } from "@/api/content";
import { Button } from "@/components";
import { useLang } from "@/i18n/LanguageContext";
import type { BlockEditorProps } from "./types";

export function LinkEditor({ content, onChange }: BlockEditorProps) {
  const { t } = useLang();
  const links = content.links ?? [];
  const set = (next: LinkItem[]) => onChange({ ...content, links: next });
  const patch = (i: number, p: Partial<LinkItem>) => set(links.map((l, j) => (j === i ? { ...l, ...p } : l)));

  return (
    <div>
      {links.length === 0 && <p className="no-data-message">{t("Nog geen links toegevoegd.", "No links yet.")}</p>}
      {links.map((l, i) => (
        <div key={i} className="block-item">
          <button className="icon-btn block-remove" title={t("Verwijderen", "Remove")} onClick={() => set(links.filter((_, j) => j !== i))}>×</button>
          <div className="field">
            <label>{t("Label", "Label")}</label>
            <input value={l.label} onChange={(e) => patch(i, { label: e.target.value })} placeholder={t("Intranet", "Intranet")} />
          </div>
          <div className="field">
            <label>URL</label>
            <input value={l.url} onChange={(e) => patch(i, { url: e.target.value })} placeholder="https://…" />
          </div>
          <div className="field" style={{ marginBottom: 0 }}>
            <label>{t("Omschrijving", "Description")}</label>
            <input value={l.description} onChange={(e) => patch(i, { description: e.target.value })} />
          </div>
        </div>
      ))}
      <Button variant="outline" onClick={() => set([...links, { label: "", url: "", description: "" }])}>+ {t("Link", "Link")}</Button>
    </div>
  );
}
